import { apiPost } from '../../api'

export const add_facilitator_to_program = data => {
  return apiPost({
    endpoint: 'programs/add_facilitator_to_program',
    data: data
  })
}
